import { render, staticRenderFns } from "./QuickActionsButton.vue?vue&type=template&id=61ad8a80"
import script from "./QuickActionsButton.vue?vue&type=script&lang=js"
export * from "./QuickActionsButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports